import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Atualize esta linha
import Home from './components/Home'; // Certifique-se de que você tenha esse componente
import RequestProposal from './components/RequestProposal';
import PreventionWorkerHealth from './components/preventionWorkerHealth';
import WomenHealthCareUnit from './components/womenHealthCareUnit';
import Tomography from './components/tomography';
import OccupationalHealthPreventionUnit from './components/occupationalHealthPreventionUnit';
import { useState, useEffect, React } from 'react';
import Loading from './components/Loading';


/**
 * The App component serves as the main container for the application.
 * It includes the Header, Unity, and Footer components arranged in sequence.
 */
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false); // Para o loading após 3 segundos
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
  if (loading) {
    return <Loading />; // Mostra o componente Loading enquanto carrega
  }
  return (

    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} /> {/* Atualize esta linha */}
          <Route path="/solicitar-proposta" element={<RequestProposal />} /> {/* Atualize esta linha */}
          <Route path="/detalhe/prevencao-e-saude-do-trabalhador" element={<PreventionWorkerHealth />} /> {/* Atualize esta linha */}
          <Route path="/detalhe/saude-e-cuidado-da-mulher" element={<WomenHealthCareUnit />} /> {/* Atualize esta linha */}
          <Route path="/detalhe/tomografia" element={<Tomography />} /> {/* Atualize esta linha */}
          <Route path="/detalhe/unidade-de-prevencao-e-saude-no-trabalho" element={<OccupationalHealthPreventionUnit />} /> {/* Atualize esta linha */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
